import Lenis from 'lenis';

let lenis = null;

export function initSmoothScroll() {
  // Honor reduced-motion preference: native scroll only.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  lenis = new Lenis({
    duration: 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    // Touch devices already have buttery native momentum; let them be.
    smoothTouch: false,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenis;
}

export function getLenis() {
  return lenis;
}

export function scrollTo(target, opts = {}) {
  if (lenis) lenis.scrollTo(target, { duration: 1.2, ...opts });
  else if (typeof target === 'string') document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  else if (target instanceof Element) target.scrollIntoView({ behavior: 'smooth' });
}

// Reveal blocks on enter, give caller a callback for time-spent / max-depth.
export function observeBlocks(root = document) {
  const els = root.querySelectorAll('.block');
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach((el) => io.observe(el));
}

// Track per-project visibility for analytics.
export function observeProjects(onChange) {
  const sections = document.querySelectorAll('.project[data-slug]');
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const slug = entry.target.getAttribute('data-slug');
        onChange(slug, entry.isIntersecting, entry.intersectionRatio);
      }
    },
    { threshold: [0, 0.25, 0.5, 0.75, 1] }
  );
  sections.forEach((s) => io.observe(s));
  return io;
}

// Returns 0..1 representing how far through the page we are.
export function pageScrollProgress() {
  const doc = document.documentElement;
  const max = doc.scrollHeight - window.innerHeight;
  if (max <= 0) return 0;
  return Math.min(1, Math.max(0, window.scrollY / max));
}
